"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-1.98 3.02h.962a2 2 0 0 1 2 2v4.008h.998a1 1 0 1 1 0 2h-3.96a1 1 0 0 1 0-2h.962V11.02h-.962a1 1 0 0 1 0-2z"
  }));
};
InfoIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.724 3.959c-.773-1.315-2.674-1.315-3.448 0L2.025 17.986C1.24 19.32 2.202 21 3.749 21h16.503c1.547 0 2.508-1.68 1.724-3.014L13.724 3.96zM13 9v4.03a1 1 0 0 1-2 0V9a1 1 0 1 1 2 0zm0 7.014v.01a1 1 0 0 1-2 0v-.01a1 1 0 1 1 2 0z"
  }));
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "callout": "callout_3STgN5",
  "icon": "icon_2fLGWz",
  "children-content": "children-content_2e7noK",
  "childrenContent": "children-content_2e7noK",
  "warning": "warning_1X5xPd",
  "info": "info_gij51h"
}; 
require('./Callout.css');
var getIcon = function getIcon(type) {
  switch (type) {
    case 'warning':
      return /*#__PURE__*/_react.default.createElement(WarningIcon, null);
    case 'info':
    default:
      return /*#__PURE__*/_react.default.createElement(InfoIcon, null);
  }
};
var Callout = function Callout(_ref) {
  var children = _ref.children,
    type = _ref.type,
    testId = _ref.testId,
    className = _ref.className,
    icon = _ref.icon,
    iconSize = _ref.iconSize;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(styles.callout, styles[type], className),
    "data-test-id": testId
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: iconSize,
    className: styles.icon
  }, icon || getIcon(type)), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.childrenContent
  }, children));
};
Callout.defaultProps = {
  className: null,
  icon: null,
  iconSize: 'xs',
  testId: 'callout',
  type: 'info'
};
var _default = exports.default = Callout;
//# sourceMappingURL=Callout.js.map